module.exports = __webpack_public_path__ + "img/link-1.c6e16223.png";